"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLUG_LEVEL = void 0;
exports.SLUG_LEVEL = {
    MAIN: 1,
    SECOND: 2,
    THIRD: 3 // Landings. ex: https://site.com/landings/[landingUrl], https://site.com/landings/[landingUrl]/[productUrl]
};
//# sourceMappingURL=slugLevel.js.map